import React from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import "react-icons/fa";
import { FaCheckCircle, FcCheckmark } from "react-icons/fc";
const ProductDescription = ({ category, description, type }) => {
  return (
    <div className="description_container">
      <h3 className="header_title">Description</h3>
      {description.map((data) => {
        const { id, header, content } = data;
        return (
          <div key={id}>
            <h3 className="product_description_header">{header}</h3>
            <p>
              <FcCheckmark /> {content}
            </p>
            <h3 className="product_specification">Specification</h3>
            <p>
              <FcCheckmark /> {category}
            </p>
            <p>
              <FcCheckmark />
              {type}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default ProductDescription;
